import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const Message: React.FC = () => {
  const { t } = useTranslation();
  return <Wrapper>{t('text.password.reset.start.request')}</Wrapper>;
};

const Wrapper = styled.div`
  margin: 4em 0 2.5em;
`;
